module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7164/images/default-avatar.png"